/**
 * 設計模板底下的「主題（配色）」預設組
 * 與後端 storefrontTemplateRegistry 之 DEFAULT_THEME_PRESETS 語意一致（代碼需同步）
 * 前台可依 storefrontTemplateId + themeId 載入對應 CSS（例如 assets/themes/<template>/<theme>.css）
 */
export const BASE_STOREFRONT_THEME_PRESETS = [
  {
    value: 'default',
    label: '經典',
    description: '預設主色與對比；對應前台預設 token。',
    preview: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  },
  {
    value: 'minimal',
    label: '簡約淺色',
    description: '淺底、低對比，偏內容與留白。',
    preview: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
  },
  {
    value: 'bold',
    label: '亮色活潑',
    description: '高飽和重點色，適合促銷與活動感。',
    preview: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  },
  {
    value: 'nature',
    label: '自然綠意',
    description: '綠色調舒緩、偏生活／食飲品牌。',
    preview: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  },
]

export function cloneBaseStorefrontThemePresets() {
  return BASE_STOREFRONT_THEME_PRESETS.map((t) => ({ ...t }))
}
